import {Title} from './styles/beacon.styled'

interface BeaconProps {
    smallSize?: boolean
}
export function Beacon({smallSize = false}: BeaconProps): JSX.Element {
    return <Title smallSize={smallSize}>Beacon</Title>
}
